import { AgentObj } from "@/types/interfaces/agents";
import {
  TIMEZONES,
  LANGUAGES,
  BOOKING_SYSTEMS_MAP,
  WORKING_DAYS,
  BRAND_NAMES,
  AGENT_STATUSES,
  EMAIL_CAMPAIGN_HOLD_REASONS,
  AGENT_NOTE_TYPES,
  TimezoneType,
  AgentNoteType,
} from "./constants";

export const getEmailCampaignHoldReason = (agent: Partial<AgentObj>): string | null => {
  if (agent.secretAgent) {
    return EMAIL_CAMPAIGN_HOLD_REASONS.PRIVATE_AGENT;
  }

  if (agent.status !== AGENT_STATUSES.LEAVING && agent.status !== AGENT_STATUSES.ACTIVE) {
    return `${EMAIL_CAMPAIGN_HOLD_REASONS.INVALID_STATUS} ${agent.status}`;
  }

  if (!agent.marketing?.emailsAllowed) {
    return EMAIL_CAMPAIGN_HOLD_REASONS.MARKETING_EMAILS_DISABLED;
  }

  if (!agent.websiteURL) {
    return EMAIL_CAMPAIGN_HOLD_REASONS.NO_WEBSITE_URL;
  }

  if (agent.agentId === null || agent.agentId === undefined) {
    return EMAIL_CAMPAIGN_HOLD_REASONS.NO_AGENT_ID;
  }

  if (agent.brandedAs !== BRAND_NAMES.TTAND && !agent.customEmailAddress) {
    return EMAIL_CAMPAIGN_HOLD_REASONS.CUSTOM_EMAIL_VERIFICATION_PENDING;
  }

  return null;
};

export const getTimezoneFullName = (tz: TimezoneType | undefined): string => {
  return tz ? TIMEZONES[tz] : "-";
};

export const getWorkingDays = (days?: Record<string, boolean> | null): string[] => {
  const workdays: string[] = [];

  Object.entries(WORKING_DAYS).forEach(([key, value]) => {
    if (days?.[key] === true) {
      workdays.push(value);
    }
  });

  return workdays;
};

export const getBookingSystemsFullNames = (systems?: string[] | null): string[] => {
  return (systems ?? []).map((system) => {
    const key = system as keyof typeof BOOKING_SYSTEMS_MAP;
    return BOOKING_SYSTEMS_MAP[key] || system;
  });
};

export const getLanguagesFullNames = (lang?: string[] | null): string[] => {
  return (lang ?? []).map((language) => {
    const key = language as keyof typeof LANGUAGES;
    return LANGUAGES[key] || language;
  });
};

export const getFilteredType = (type: AgentNoteType): string => {
  return AGENT_NOTE_TYPES[type] || type;
};

export const getRelativeTimeString = (timestamp: string): string => {
  const now = new Date();
  const past = new Date(timestamp);

  if (isNaN(past.getTime())) {
    return "Invalid date";
  }

  const diffInMs = now.getTime() - past.getTime();

  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInMinutes < 60) {
    return `${diffInMinutes} ${diffInMinutes === 1 ? "minute" : "minutes"} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours} ${diffInHours === 1 ? "hour" : "hours"} ago`;
  } else {
    return `${diffInDays} ${diffInDays === 1 ? "day" : "days"} ago`;
  }
};
